import { apiSlice } from "@/shared/api/api-slice"
import { chatIdMutation } from "@/shared/api/queries"

import type { UnlockCustomStyleRequest, UnlockCustomStyleResponse } from "./card-style-types"
import { getUserCardStyleTag } from "./get-user-card-style"

export const unlockCustomStyleApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["UserCardStyle", "Balance"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      unlockCustomStyle: builder.mutation<UnlockCustomStyleResponse, UnlockCustomStyleRequest>({
        queryFn: chatIdMutation<UnlockCustomStyleRequest, UnlockCustomStyleResponse>(chatId => ({
          url: "/api/v1/card-styles/me/unlock-custom",
          method: "POST",
          body: { chat_id: chatId }
        })),
        invalidatesTags: (_result, error, { chatId }) => (error ? [] : [getUserCardStyleTag(chatId), "Balance"])
      })
    })
  })

export const { useUnlockCustomStyleMutation } = unlockCustomStyleApi
